import React from 'react';
import DatasetAttachmentCardItem from './DatasetAttachmentCardItem';
import DatasetFolderCardItem from './DatasetFolderCardItem';
import { ATTACHMENT_TYPE } from '../constants';
import { getAttachmentType } from '../helper';

const CardComponentMap = {
  [ATTACHMENT_TYPE.folder.name]: DatasetFolderCardItem,
  [ATTACHMENT_TYPE.attachment.name]: DatasetAttachmentCardItem,
  [ATTACHMENT_TYPE.datafile.name]: DatasetAttachmentCardItem,
};

const DatasetAttachmentCardItems = ({ category, code, items }) => (items.map((attachment, index) => {
  const attachmentType = getAttachmentType(attachment);
  const CardComponent = CardComponentMap[attachmentType.name];

  return (
    <CardComponent
      attachment={attachment}
      category={category}
      code={code}
      key={`dataset_attachment_card_${attachment.id}`}
      upward={index >= 4}
    />
  );
})
);

export default DatasetAttachmentCardItems;
